import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './style.module.scss';

export default class ProfileHeader extends PureComponent {
  static propTypes = {
    progress: PropTypes.number.isRequired,
  };

  render() {
    return (
      <div className={styles.innerHeader}>
        <p>
          We&rsquo;re asking you a few questions to help find you the best
          space.
        </p>
        <p>This will only take a few minutes.</p>
        <div className={styles.progressBar}>
          <div style={{ width: 100 * this.props.progress + '%' }} />
        </div>
      </div>
    );
  }
}
